import axios from "axios";

// Use HTTPS backend URL with fallback to relative URL
const getBaseURL = () => {
  // Force HTTPS backend URL
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  if (backendUrl) {
    console.log('✅ Using backend URL:', backendUrl + '/api');
    return backendUrl + '/api';
  }
  // Fallback to relative URL (will use current page protocol)
  const fallbackUrl = window.location.origin + '/api';
  console.log('⚠️ Using fallback URL:', fallbackUrl);
  return fallbackUrl;
};

const api = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor - add auth token to every request
api.interceptors.request.use(
  (config) => {
    // Try both token keys for backward compatibility
    const token = localStorage.getItem("token") || localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle 401 with token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If 401 and haven't retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      // Check if this request should skip auto-redirect (e.g., password validation)
      if (originalRequest.skipAuthRedirect) {
        return Promise.reject(error);
      }

      originalRequest._retry = true;

      const refreshToken = localStorage.getItem("refresh_token");
      if (!refreshToken) {
        // No refresh token, redirect to login
        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject(error);
      }

      try {
        // Try to refresh token using legacy adapter
        const refreshUrl = process.env.REACT_APP_BACKEND_URL 
          ? `${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh-legacy`
          : `${window.location.origin}/api/auth/refresh-legacy`;
          
        const { data } = await axios.post(refreshUrl, {
          refresh_token: refreshToken
        });

        // Save new tokens
        localStorage.setItem("access_token", data.access_token);
        if (data.refresh_token) {
          localStorage.setItem("refresh_token", data.refresh_token);
        }

        // Retry original request with new token
        originalRequest.headers.Authorization = `Bearer ${data.access_token}`;
        return api(originalRequest);
      } catch (refreshError) {
        // Refresh failed, redirect to login
        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
